module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "kp-btn-action-sm kp-btn__danger",
    on: {
      "click": function($event) {
        return _vm.jumpRemove({
          id: _vm.jumpId,
          index: _vm.index
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7a10930c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/buttons/Remove.vue
 ** module id = 870
 ** module chunks = 1
 **/